import { Vue, Prop, Component } from 'vue-property-decorator';
import { fetchAnliticasUso } from './fetchAnliticasUso';

export default class Analitica extends Vue {
  @Prop({ default: 0 }) id_analitica: Number;
  @Prop({ default: 0 }) modulo: any;
  @Prop({ default: 0 }) path: any;

  constructor(modulo: number, path: any) {
    super();
    this.modulo = modulo;
    this.path = path;
  }

  entrada(): any {
    return fetchAnliticasUso(
      {
        modulo: this.modulo,
        path: this.path,
        usuarioid: this.getUserID(),
        clienteid: this.getCliente(),
      },
      'SucursalVirtualAnaliticasUso/entrada'
    )
      .then((data: any) => {
        console.log(data);
        this.id_analitica = data.data.id;
      })
      .catch((error: any) => {
        console.log(error);
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  salida(id: Number): any {
    return fetchAnliticasUso(
      {
        id: id,
        modulo: this.modulo,
        path: this.path,
        usuarioid: this.getUserID(),
        clienteid: this.getCliente(),
      },
      'SucursalVirtualAnaliticasUso/salida'
    )
      .then((data: any) => {
        this.id_analitica = data.data.id;
      })
      .catch((error: any) => {
        console.log(error);
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    console.log(id);
    return id;
  }
  getCliente() {
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  async generate_analytic_id() {
    return fetchAnliticasUso(
      {},
      'SucursalVirtualAnaliticasUso/get_analitica_id'
    )
      .then((data: any) => {
        this.id_analitica = data.data.proximo_id;
        return this.id_analitica;
      })
      .catch((error: any) => {
        console.log(error);
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  get_analytic_id(): any {
    return this.id_analitica;
  }
}
